import { ColumnDef } from "@tanstack/react-table";
import { DataTable } from "@common/components/Table/DataTable";
import { DataTableColumnHeader } from "@common/components/Table/DataTableColumnHeader";
import { Body } from "@hypercard/web-components";
import { Button } from "@/components/ui/button";
import { CustomFieldEntity } from "@common/utils/graphql";
import { CaretRight } from "@phosphor-icons/react";
import { isListField } from "@common/components/CustomFields";

const getColumns = (
  onEdit: (customField: CustomFieldEntity) => void,
): ColumnDef<CustomFieldEntity>[] => [
  {
    id: "name",
    enableSorting: false,
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Name" />
    ),
    cell: ({ row }) => {
      const activeListOptions = row.original.listOptions?.filter(
        (option) => !option.isDeleted,
      );
      const numberOfOptions = activeListOptions?.length ?? 0;

      return (
        <div>
          <Body size="md" weight="medium">
            {row.original.name}
          </Body>
          {isListField(row.original) && (
            <Body size="sm" weight="regular" className="text-white/70">
              {`${numberOfOptions} ${numberOfOptions === 1 ? "option" : "options"}`}
            </Body>
          )}
        </div>
      );
    },
  },
  {
    id: "type",
    enableSorting: false,
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Field Type" />
    ),
    cell: ({ row }) => (
      <Body size="md" weight="regular" className="capitalize">
        {row.original.type}
      </Body>
    ),
  },
  {
    enableSorting: false,
    id: "state",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Field State" />
    ),
    cell: ({ row }) => (
      <Body size="md" weight="regular" className="capitalize">
        {row.original.state}
      </Body>
    ),
  },
  {
    enableSorting: false,
    id: "manage",
    cell: ({ row }) => (
      <div className="flex justify-end">
        <Button variant="secondary" onClick={() => onEdit(row.original)}>
          Manage <CaretRight weight="bold" className="ml-2 size-2.5" />
        </Button>
      </div>
    ),
  },
];

type Props = {
  customFields: CustomFieldEntity[];
  onEdit: (customField: CustomFieldEntity) => void;
};

export const CustomFieldsTable = ({ customFields, onEdit }: Props) => {
  const columns = getColumns(onEdit);
  return <DataTable columns={columns} data={customFields} />;
};
